import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 md:py-32 bg-cream px-6" data-id="element-172">
      <div className="container mx-auto max-w-4xl" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-174">
          <h2 className="text-3xl md:text-5xl font-bold text-wine-dark mb-8 text-center" data-id="element-175">
            Esto le pasa a parejas “normales”
          </h2>
          <div className="prose prose-lg mx-auto text-charcoal/80 leading-relaxed" data-id="element-176">
            <p className="mb-6" data-id="element-177">
              Parejas que se quieren. Parejas que se ríen juntos. Parejas que,
              por fuera, están bien.
            </p>
            <p className="mb-6" data-id="element-178">
              Pero cuando llega el momento de acercarse… algo se apaga. No
              porque no haya atracción. Sino porque el acercamiento se volvió{' '}
              <strong className="text-wine font-semibold" data-id="element-179">
                un riesgo emocional
              </strong>
              .
            </p>
            <p data-id="element-180">
              Porque iniciar se siente como exponerte. Y si te dicen que no…
              duele más de lo que quieres admitir.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border-l-4 border-wine" data-id="element-181">
          <h3 className="text-2xl md:text-4xl font-bold text-charcoal mb-6 text-center" data-id="element-182">
            El problema no es la pasión. <br data-id="element-183" />
            <span className="text-wine italic" data-id="element-184">Es la exposición.</span>
          </h3>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-185">
            <div data-id="element-186">
              <p className="text-lg text-charcoal/80 mb-4" data-id="element-187">
                La mayoría intenta arreglar esto con consejos que solo aumentan
                la presión:
              </p>
              <ul className="space-y-3" data-id="element-188">
                {['hay que echarle ganas', 'hay que prender la chispa', 'hay que planear algo sexy', 'hay que hablarlo'].map((item, i) => <li key={i} className="flex items-center text-charcoal/70" data-id="element-189">
                    <span className="w-2 h-2 bg-wine/40 rounded-full mr-3" data-id="element-190"></span>
                    "{item}"
                  </li>)}
              </ul>
            </div>
            <div className="bg-cream-dark p-6 rounded-xl" data-id="element-191">
              <p className="text-lg font-medium text-wine-dark italic text-center" data-id="element-192">
                "Pero todo eso, para alguien con vergüenza, suena a: 'Haz un
                intento grande… y arriesga que te rechacen.' Y por eso no
                funciona."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}